module.exports = __webpack_public_path__ + "static/media/alert.44388a4e.svg";